





























import { computed, defineComponent, ref } from "@vue/composition-api";
import { VaultCategory } from "@scrile/api-provider/dist/api/VaultsProvider";
import { $t } from "@/lib/i18nHelpers";
import { BaseMenuItem } from "@/types";
import BaseIcon from "@/components/BaseIcon";
import BaseIconButton from "@/components/BaseIconButton";
import BaseMenu from "@/components/BaseMenu";
import CategoryDeleteConfirmation from "../CategoryDeleteConfirmation";
import VaultUpdateCategoryModal from "../VaultUpdateCategoryModal";

export default defineComponent({
  name: "VaultMenu",
  components: { BaseMenu, CategoryDeleteConfirmation, VaultUpdateCategoryModal, BaseIcon, BaseIconButton },
  props: {
    allowAi: { type: Boolean, default: false },
    selectedCategory: { type: Object as () => VaultCategory, required: true },
  },
  setup(props, { emit }) {
    const showDeleteConfirmation = ref(false);
    const showRenameModal = ref(false);
    const menuItems: BaseMenuItem[] = [
      {
        name: "manage",
        text: $t("Manage"),
      },
      {
        name: "edit",
        text: $t("Edit"),
      },
      {
        name: "delete",
        text: $t("Delete"),
      },
    ];
    const isCategoryContainsFiles = computed<boolean>(() => (props.selectedCategory?.files ?? []).length > 0);
    const items = computed<BaseMenuItem[]>(() =>
      menuItems.filter(item => {
        if (item.name === "manage" && !isCategoryContainsFiles.value) {
          return false;
        }
        if (item.name === "manage" && props.selectedCategory.system && isCategoryContainsFiles.value) {
          return true;
        }

        return !props.selectedCategory.system;
      })
    );

    const onDelete = () => {
      emit("delete");
      showDeleteConfirmation.value = false;
    };

    return { items, showDeleteConfirmation, onDelete, showRenameModal };
  },
});
